import { MSTableColumnSettingMainHeaderProps } from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/column-setting/sortable-context/main-header";
import { useSortable } from "@dnd-kit/sortable";
import { SHBox, SHStack, SHTypography } from "@components/design-systems";
import { HamburgerSVG } from "@components/svgs/hamburger";
import React from "react";
import { MSTableColumnSettingIconButton } from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/column-setting/sortable-context/tooltip-button";
import { IconButton, useTheme } from "@mui/material";
import { MSTableColumnSettingSubHeaderVisibilityCheckbox } from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/column-setting/sortable-context/sub-header/visibility-checkbox";

type MSTableColumnSettingSubHeaderProps =
  MSTableColumnSettingMainHeaderProps & {
    mainHeaderId: string;
  };

export const MSTableColumnSettingSubHeader = React.memo(
  ({ item, mainHeaderId, disabled }: MSTableColumnSettingSubHeaderProps) => {
    const { palette } = useTheme();
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({ id: item.id });

    return (
      <SHStack
        ref={setNodeRef}
        {...attributes}
        {...(disabled ? undefined : listeners)}
        direction={"column"}
        sx={{
          transform: transform
            ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
            : undefined,
          transition,
          zIndex: 1,
          cursor: "grab",
          ":active": {
            cursor: "grabbing",
            zIndex: 2,
          },
        }}
      >
        <SHStack
          className={"MSTableColumnSettingSubHeader"}
          direction={"row"}
          bgcolor={palette.common.whitesmoke}
          paddingY={1}
          paddingLeft={2}
          borderRadius={"4px"}
          justifyContent={"space-between"}
          borderBottom={"1px solid transparent"}
          sx={{
            ...(isDragging && {
              borderBottom: `1px solid ${palette.primary.main}`,
              backgroundColor: palette.common.lightSteelBlue,
              filter: "drop-shadow(1px 1px 2px rgba(65, 73, 89, 0.25))",
              transition:
                "background-color 300ms ease, border-bottom 300ms ease",
              cursor: "grabbing !important",
            }),
          }}
        >
          <SHStack gap={1} direction={"row"} alignItems={"center"}>
            <SHBox
              component={"span"}
              onPointerDown={(e) => e.stopPropagation()}
            >
              <MSTableColumnSettingSubHeaderVisibilityCheckbox
                mainHeaderId={mainHeaderId}
                subHeaderId={item.id}
                defaultChecked={item.isVisible}
                disabled={disabled}
              />
            </SHBox>

            <SHTypography variant={"subtitle2"} disabled={disabled}>
              {item.name}
            </SHTypography>
          </SHStack>

          <SHStack marginRight={0.5}>
            <MSTableColumnSettingIconButton
              title={"Move"}
              icon={
                <IconButton
                  disabled
                  sx={{
                    padding: 1,
                  }}
                >
                  <HamburgerSVG
                    width={18}
                    height={18}
                    color={disabled ? palette.action.disabled : undefined}
                  />
                </IconButton>
              }
              popperSx={{
                marginTop: "0px !important",
              }}
            />
          </SHStack>
        </SHStack>
      </SHStack>
    );
  },
);
